import React from 'react'
import {getEventId} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {EventLink} from '../../styled-components/event-link'
import {downloadTicketsForEvent} from '../../../services/tickets'
import {isTicketedWithNoOrder} from '../../../selectors/event'
import {DownloadTicketsButtonProps} from './index'

export const DownloadTicketsButton: React.FC<DownloadTicketsButtonProps> = ({
  mobile,
  event,
  tickets,
  downloadTicketsAction,
  t,
}) => {
  const eventId = getEventId(event.event)
  const ticketedWithNoOrder = isTicketedWithNoOrder(event)
  const eventTickets = tickets[eventId]

  const handleDownload = () => {
    ticketedWithNoOrder
      ? downloadTicketsForEvent({event, hasOrder: false, tickets: eventTickets})
      : downloadTicketsForEvent({event})
    downloadTicketsAction(eventId)
  }

  return (
    <EventLink
      secondary={mobile}
      mobile={mobile}
      onClick={handleDownload}
      data-hook={DH.BUTTON_DOWNLOAD_TICKETS}
      disabled={ticketedWithNoOrder && !eventTickets}
    >
      {t('events.buttons.download-tickets')}
    </EventLink>
  )
}
